"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ProviderBase_1 = require("../ProviderBase");
var DxmList_1 = require("./DxmList");
var DxmProvider = /** @class */ (function (_super) {
    __extends(DxmProvider, _super);
    function DxmProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getQuery = function (queryOptions, translationHelper) {
            var query;
            var name = _this.request.name;
            if (name === 'list') {
                query = new DxmList_1.DxmList(queryOptions, translationHelper);
            }
            return query;
        };
        return _this;
    }
    return DxmProvider;
}(ProviderBase_1.ProviderBase));
exports.DxmProvider = DxmProvider;
//# sourceMappingURL=DxmProvider.js.map